var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){$event.preventDefault();return _vm.addToCart.apply(null, arguments)}}},[(_vm.inCart)?_c('div',{staticClass:"icon icon-cart-in"}):_c('div',{staticClass:"icon icon-in-cart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }